import { ButtonBase, type ButtonBaseProps } from '@pets-ui/ButtonBase/ButtonBase'
import { ArrowDownLarge } from '@pets-ui/icons'
import { Image } from '@pets-ui/Image/Image'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
import { ProductSalesTag } from '../ProductSalesTag/ProductSalesTag'

const styles = stylex.create({
  root: {
    margin: 0,
    alignItems: 'center',
    columnGap: '8px',
    display: 'flex',
    width: '100%',
  },
  titleWrapper: {
    flex: '1',
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  inCart: {
    color: '#6bbc88',
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  icon: {
    marginLeft: 'auto',
  },
  iconActive: {
    transform: 'rotate(180deg)',
  },
})

export interface CollapseProductButtonProps extends Omit<ButtonBaseProps, 'children'> {
  thumbnail: string
  title: string
  countProduct: number
  onProductImageClick?: () => void
  onProductNameClick?: () => void
  showProductSalesTag?: boolean
  open?: boolean
}

export const CollapseProductButton = (props: CollapseProductButtonProps) => {
  const {
    rootStyle,
    thumbnail,
    title,
    countProduct,
    onProductImageClick,
    onProductNameClick,
    showProductSalesTag,
    open,
    ...rest
  } = props

  return (
    <ButtonBase
      rootStyle={[styles.root, rootStyle]}
      disableRipple
      {...rest}
    >
      <ProductSalesTag show={showProductSalesTag}>
        <Image
          width={72}
          height={72}
          src={thumbnail}
          alt={title}
          onClick={onProductImageClick}
          loading="lazy"
          loadingFallback={<Skeleton width={72} height={72} />}
        />
      </ProductSalesTag>
      <div {...stylex.props(styles.titleWrapper)}>
        <Text component="h4" fontWeight={600} onClick={onProductNameClick}>{title}</Text>
        {countProduct > 0 && (
          <span {...stylex.props(styles.inCart)}>
            已選擇：
            {countProduct}
          </span>
        )}
      </div>
      <ArrowDownLarge
        rootStyle={[
          styles.icon,
          open && styles.iconActive,
        ]}
      />
    </ButtonBase>
  )
}
